export default __webpack_public_path__ + "static/media/stomach_plot_male.d28d798a.png";